import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row, Container } from "reactstrap";
import * as actionCreators from "../../../../modules/actions/index";
import * as url from "../../../../utils/url";
import { connect } from "react-redux";
import findIndex from "lodash/findIndex";
import axios from "../../../../axios";
import { saveAs } from "file-saver";
import {
  addToolStep,
  CANVAS_PROXY_IMAGE_URL,
  NO_CONTENT_MESSAGE,
  staticTitles,
} from "../../../../utils/constants";
import { toolkitCategories } from "../../../../utils/categories";
import { getCountries } from "../../../../utils/countries";
import { getStatesByCountryCode } from "../../../../utils/states";
import DetailsSection from "../Sections/DetailsSection/DetailsSection";
import MoreSection from "../Sections/MoreSection/MoreSection";
import HeaderSection from "../Sections/HeaderSection/HeaderSection";
import CommentsSection from "../Sections/CommentsSection/CommentsSection";
import ContactModal from "./ContactModal";
import get from "lodash/get";
import size from "lodash/size";
import ShareModal from "./ShareModal";
import ArchiveModal from "./ArchiveModal";
import AddRatingModal from "./AddRatingModal";
import isEmpty from "lodash/isEmpty";
import ToolWarningModal from "./ToolWarningModal";
import Loading from "../../../../hoc/Loading/Loading";
import {
  canEditTool,
  canArchiveAndRestoreTool,
  canRemoveShareToolEmails,
} from "../../../../utils/privacySettings";
import html2canvas from "html2canvas";
import { socketConnection } from "./../../../../socketClient";
import ExportableTool from "./ExportableTool";
import EmptyStage from "../../../empty-stage/NoData/NoData";
import moment from "moment";
import AddToGroup from "../../../../components/AddToGroup/AddToGroup";
import EventDetails from "./EventDetails";
import EventsMap from "../../../../components/AddressSearch/EventsMap";
import { toastContainer } from "../../../../utils/toast";

class ToolDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolDetails: {},
      allComments: [],
      displayComments: [],
      isGroupModal: false,
      commentPage: 0,
      isExporting: false,
      showContactModal: false,
      showShareModal: false,
      showArchiveModal: false,
      showAddRatingModal: false,
      showWarningModal: false,
      orgUserList: [],
      warningModalAction: "",
      isToolRecommendedAndArchive: false,
      isGroupEvent:false
    };
    this.toolDetailRef = null;
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(this.props.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  componentWillMount() {
    // console.log(this.props);
    // const params = new URLSearchParams(this.props.location.search);
    if (!this.props.isPopup) {
      const category = this.props.match.params.category;
      // const notificationId = params.get('notification');
      const notificationId = this.getUrlParameter("notification");

      if (notificationId) {
        let link = "";
        for (let toolkitCategory of toolkitCategories) {
          if (toolkitCategory.name === category) {
            link = toolkitCategory.link;
          }
        }
        // this.props.history.push(`/home/toolkit/${link}/tool/5bc064c261563645ca13cf16`);
      }
    }
  }

  componentWillUnmount() {
    this.props.updateNavBar({
      backButtonData: {
        show: false,
        currentPageType: "",
      },
    });
  }

  componentDidMount = () => {
    this.props.updateNavBar({
      backButtonData: {
        show: true,
        currentPageType: "TOOL_DETAILS",
      },
    });
    let id = this.props.match.params.id;

    const groupId = this.props.match.params.groupId;

    if(groupId){
      this.setState({isGroupEvent:true})
    }
    // let {id}=this.props.toolDetails

    this.getToolDetails(id);

    // axios.get(url.getToolkitComments(id)).then(({data}) => {
    //   if(data.data)
    //   let { comments } = data.data;
    //   this.setState({
    //     allComments : comments,
    //     displayComments : comments.slice(0,2)
    //   });
    // });

    // const unlisten = this.props.history.listen((location, action) => {
    //   const category = this.props.match.params.category;
    //   let id = this.props.match.params.id;
    //   if (action === 'POP' && location.pathname.startsWith(`/home/toolkit/${category}/tool/${id}`)) {
    //     this.props.history.goBack();
    //   } else {
    //     unlisten();
    //   }
    // })
  };

  componentWillReceiveProps(nextProps) {
    let { toolDetails } = nextProps;
    const category = this.props.match.params.category;
    if (
      toolDetails &&
      toolDetails.redirectionPath &&
      (toolDetails.redirectionPath.startsWith(`/home/toolkit/${category}/edit/`)|| toolDetails.redirectionPath.startsWith(`/home/toolkit/${this.props.match.params.groupId}/${category}/edit/`))
    ) {
      // console.log(toolDetails)
      this.props.history.push(toolDetails.redirectionPath);
    }
    let oldToolId = this.props.match.params.id;
    let toolId = nextProps.match.params.id;
    if (oldToolId !== toolId) {
      this.getToolDetails(toolId);
    }
  }

  toggleContactModal = () => {
    this.setState((prev) => ({ showContactModal: !prev.showContactModal }));
  };

  toggleShareModal = () => {
    this.setState((prev) => ({ showShareModal: !prev.showShareModal }));
  };

  toggleArchiveModal = () => {
    this.setState((prev) => ({ showArchiveModal: !prev.showArchiveModal }));
  };

  toggleRatingModal = () => {
    this.setState((prev) => ({ showAddRatingModal: !prev.showAddRatingModal }));
  };

  toggleWarningModal = () => {
    this.setState((prev) => ({ showWarningModal: !prev.showWarningModal }));
  };

  handleExportClick = () => {
    let { toolDetails } = this.state;
    this.setState(
      {
        isExporting: true,
      },
      () => {
        // ReactDOM.findDOMNode(this.toolDetailRef).style.display="block";
        let node = ReactDOM.findDOMNode(this.toolDetailRef);

        this.setState({ isExporting: false });

        html2canvas(node, {
          useCORS: true,
          allowTaint: true,
          proxy: CANVAS_PROXY_IMAGE_URL,
        }).then((canvas) => {
          canvas.toBlob((blob) => {
            let newWindow = window.open("/");
            if (newWindow) {
              newWindow.location = URL.createObjectURL(blob);
            } else {
              // empty
            }

            let name =
              toolDetails && toolDetails.name
                ? `${toolDetails.name}.png`
                : "tooldetail.png";
            saveAs(blob, name);
          });
        });
      }
    );
  };

  handleShowShareModal = () => {
    const { toolDetails } = this.state;
    let { orgUserList } = this.state;
    if (orgUserList && orgUserList.length > 0) {
      this.toggleShareModal();
    } else {
      this.getOrgUserList();
    }
  };

  // Get organization user list to show it on share modal
  getOrgUserList = () => {
    axios
      .get(url.getOrgUserList)
      .then((response) => {
        //  console.log(response.data.data)
        this.setState({
          orgUserList: response.data.data,
          showShareModal: true,
        });
      })
      .catch((error) => {
        this.setState({ orgUserList: [] });
      });
  };

  getToolDetails(id) {
    // console.log(this.props.user)

    let cat = this.props.match.params.category

    if(id=="undefined"){
      if(cat){
        this.props.history.push(`/home/toolkit/${cat}`)
        toastContainer(NO_CONTENT_MESSAGE,"error")
      }else{
        this.props.history.push("/home/toolkit/all")
        toastContainer(NO_CONTENT_MESSAGE,"error")
      }
      
      return;
    }

    axios
      .get(url.getTool(id))
      .then((response) => {
        let toolDetails = response.data;

        if (toolDetails.isRecommendedByAdmin && toolDetails.isArchive.value) {
          this.setState({
            isToolRecommendedAndArchive: true,
            toolDetails: undefined,
          });
          return;
        }
        let diversityFocus = toolDetails.categoryTypes["1"];
        let relevantFor = toolDetails.categoryTypes["2"];
        toolDetails.diversityFocus = [];
        toolDetails.relevantFor = [];
        if (diversityFocus && diversityFocus.length > 0) {
          toolDetails.diversityFocus = diversityFocus.map((selectedFocus) => {
            return { key: selectedFocus._id, focus: selectedFocus.focus };
          });
        }
        if (relevantFor && relevantFor.length > 0) {
          toolDetails.relevantFor = relevantFor.map((selectedFocus) => {
            return { key: selectedFocus._id, focus: selectedFocus.focus };
          });
        }
        delete toolDetails.categoryTypes;
        if (
          toolDetails.toolkitTags &&
          toolDetails.toolkitTags.relevantForTags &&
          toolDetails.toolkitTags.relevantForTags.length > 0
        ) {
          toolDetails.relevantForTags = toolDetails.toolkitTags.relevantForTags.toString();
          toolDetails.relevantFor.push({
            key: "otherRelevantFor",
            focus: "Other",
            type: "relevantForTag",
          });
        }
        if (
          toolDetails.toolkitTags &&
          toolDetails.toolkitTags.diversityFocusTags &&
          toolDetails.toolkitTags.diversityFocusTags.length > 0
        ) {
          toolDetails.diversityFocusTags = toolDetails.toolkitTags.diversityFocusTags.toString();
          toolDetails.diversityFocus.push({
            key: "otherDiversityFocus",
            focus: "Other",
            type: "diversityFocusTag",
          });
        }

        if (
          toolDetails.subCategory &&
          toolDetails.subCategory !== "" &&
          toolDetails.subCategory !== null
        ) {
          toolDetails.subCategory = {
            subCategoryKey: toolDetails.subCategory,
            subCategoryValue: toolDetails.subCategory,
          };
        }

        if (toolDetails.locations && toolDetails.locations.length > 0) {
          let states = [];
          let allCountries = getCountries();
          let allState = getStatesByCountryCode("US");
          let selectedCountries = toolDetails.locations.map(
            (location) => location.country
          );
          let selectedStates = toolDetails.locations.map(
            (location) => location.states
          );
          selectedStates = selectedStates.filter((states) => states.length > 0);
          let countries = allCountries.filter(
            (country) => selectedCountries.indexOf(country.name) !== -1
          );
          if (selectedStates.length > 0) {
            states = allState.filter(
              (state) => selectedStates[0].indexOf(state.name) !== -1
            );
          }
          toolDetails["selectedLocations"] = { countries, states };
        } else {
          toolDetails["selectedLocations"] = { countries: [], states: [] };
        }

        delete toolDetails.toolkitTags;

        // Socket call for Saving ToolName, Is Recommended and Tool count.

        // socketConnection.track("Add_Ratings_Click", {
        //   toolName : toolDetails.name,
        //   ratingsCount : toolDetails.ratings.length,
        //   ratingScore : toolDetails.avgRating,
        //   isRecommended : toolDetails.isRecommendedByAdmin
        // });

        let commentObj = {};
        if (
          toolDetails &&
          toolDetails.comments &&
          toolDetails.comments.length > 0
        ) {
          commentObj = {
            allComments: toolDetails.comments,
            displayComments: toolDetails.comments.slice(0, 2),
          };
        } else {
          commentObj = {
            allComments: [],
            displayComments: [],
          };
        }

        console.log("details ---- ", toolDetails);
        this.setState({
          toolDetails: toolDetails,
          ...commentObj,
        });
      })
      .catch((error) => {
        
        console.log(error);

        if(cat){
          this.props.history.push(`/home/toolkit/${cat}`)
          toastContainer(NO_CONTENT_MESSAGE,"error")
        }else{
          this.props.history.push("/home/toolkit/all")
          toastContainer(NO_CONTENT_MESSAGE,"error")
        }
      });
  }

  backToEdit = () => {
    this.props.onToolBackToEditPressed({
      nextStep: addToolStep.info,
      isPrivacySettingsChanged: false,
    });
  };

  navigateToToolkitategory = () => {
    let link = "";
    for (let category of toolkitCategories) {
      if (category.name === this.state.toolDetails.category) {
        link = category.link;
      }
    }
    this.props.history.push("/home/toolkit/" + link);
  };

  handleEditTool = () => {
    const category = this.props.match.params.category;
    let editToolDetails = { ...this.state.toolDetails };
    if (!editToolDetails.isArchive.value) {
      editToolDetails.nextStep = addToolStep.info;
      this.props.onToolEditLoaded({
        ...editToolDetails,
        redirectionPath: this.state.isGroupEvent ? `/home/toolkit/${this.props.match.params.groupId}/${category}/edit/${editToolDetails._id}` :`/home/toolkit/${category}/edit/${editToolDetails._id}`,
      });
    } else {
      this.setState({ showWarningModal: true, warningModalAction: "edit" });
    }
  };

  handleRateToolAllowed = () => {
    let editToolDetails = { ...this.state.toolDetails };
    if (!editToolDetails.isArchive.value) {
      this.toggleRatingModal();
    } else {
      this.setState({ showWarningModal: true, warningModalAction: "rate" });
    }
  };

  handleArchiveTool = () => {
    const { toolDetails } = this.state;

    let userRole =
      this.props.user && this.props.user.orgAdmin
        ? "ADMIN"
        : this.props.user._id == toolDetails.createdBy._id
        ? "OWNER"
        : false;

    axios
      .put(url.archiveTools, { list: [this.state.toolDetails._id], userRole })
      .then((response) => {
        let val = { ...this.state.toolDetails };
        val.isArchive.value = true;
        this.setState({ val, showArchiveModal: false });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleRestoreArchivedTool = () => {
    axios
      .put(url.restoreTool, { list: [this.state.toolDetails._id] })
      .then((response) => {
        // this.setState({toolDetails: {...this.state.toolDetails, "isArchive.value": false }} );
        let val = { ...this.state.toolDetails };
        val.isArchive.value = false;
        this.setState({ val });
      })
      .catch((error) => {});
  };

  handleAddOrRemoveFavorite = () => {
    if (this.state.toolDetails.isFavorite) {
      this.handleRemoveToFavorite();
    } else {
      this.handleAddToFavorite();
    }
  };

  handleAddToFavorite = () => {
    // console.log(this.state)

    axios
      .post(url.addToFavorites, { ids: [this.state.toolDetails._id] })
      .then((response) => {
        this.setState({
          toolDetails: { ...this.state.toolDetails, isFavorite: true },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleRemoveToFavorite = () => {
    axios
      .put(url.removeFromFavorites, { ids: [this.state.toolDetails._id] })
      .then((response) => {
        this.setState({
          toolDetails: { ...this.state.toolDetails, isFavorite: false },
        });
      })
      .catch((error) => {});
  };

  handleRateTool = (score) => {
    const { toolDetails } = this.state;
    const { dani } = this.props.history.location;
    axios
      .post(url.rateTool(this.state.toolDetails._id), { score })
      .then((response) => {
        this.getToolDetails(this.state.toolDetails._id);
        this.toggleRatingModal();

        // console.log("daniDetails", dani);
        // console.log("toolDetailsInRating", {toolDetails, score});

        // Socket Event - Add_Ratings_Click

        if (isEmpty(dani.selectedChart)) {
          // Event binding when navigation flow is  -> Tool -> ToolDetails
          // socketConnection.track("Add_Ratings_Click", {
          //   toolName : toolDetails.name,
          //   ratingsCount : score,
          //   ratingScore : toolDetails.avgRating,
          //   isRecommended : toolDetails.isRecommendedByAdmin
          // });
        } else {
          // Event binding when navigation flow is Dani ->  -> Tool -> ToolDetails
          // socketConnection.track("Dani_Tool_Ratings_Click", {
          //   kpiName : 'test',
          //   toolkitCategoryName : get(toolDetails, 'category', ''),
          //   toolSubcategoryName : toolDetails.subCategory.subCategoryValue,
          //   toolkitName : get(toolDetails, 'name', ''),
          //   isRecommended : get(toolDetails, 'isRecommendedByAdmin', ''),
          //   ratingScore : size(toolDetails.ratings),
          // });
        }
      })
      .catch((error) => {});
  };

  handleAddComment = (commentText) => {
    let id = this.props.match.params.id;
    const { firstName, lastName } = this.props.user;
    let { allComments, displayComments } = this.state;
    const dateTime = moment().toISOString();
    const comment = {
      date: dateTime,
      text: commentText,
      // userId: { firstName: firstName, lastName: lastName },
      userId: this.props.user,
    };
    allComments = [comment, ...allComments];
    // allComments.push(comment);
    // displayComments.push(comment);
    displayComments = [comment, ...displayComments];
    this.setState({
      allComments: allComments,
      displayComments: displayComments,
    });
    console.log(allComments.length, "-----testing add comment ---", id);
    axios
      .post(url.addToolkitComment, { toolId: id, text: commentText })
      .then(({ data }) => {
        const comment = data.data;
        const i = findIndex(allComments, { date: dateTime });
        const j = findIndex(displayComments, { date: dateTime });
        allComments.splice(i, 1, comment);
        displayComments.splice(j, 1, comment);
        // this.setState({
        //   allComments: allComments,
        //   displayComments: displayComments,
        // });
      });
  };

  handleSeeMoreComments = () => {
    console.log("testig new comments --- ");
    const { commentPage, allComments, displayComments } = this.state;
    console.log(allComments, "----- commentPage --- ", commentPage);
    let nextComments = [];
    if (commentPage === 0) {
      nextComments = allComments.slice(0, 5);
    } else {
      const start = commentPage * 5;
      nextComments = displayComments.concat(
        allComments.slice(start, start + 5)
      );
    }
    console.log("nextComments---", nextComments);
    this.setState({
      displayComments: nextComments,
      commentPage: commentPage + 1,
    });
  };

  handleDeleteComment = (commentId) => {
    let id = this.props.match.params.id;
    const { allComments, displayComments } = this.state;
    const i = findIndex(allComments, { _id: commentId });
    allComments.splice(i, 1);
    const j = findIndex(displayComments, { _id: commentId });
    displayComments.splice(j, 1);
    this.setState({
      allComments: allComments,
      displayComments: displayComments,
    });
    axios.delete(url.deleteToolkitComment(id, commentId)).then(({ data }) => {
      //do nothing.
    });
  };

  handleShareTool = (data) => {
    let { toolDetails } = this.state;
    let { _id, publicShare } = toolDetails;
    axios
      .post(url.shareToolWithOther(_id), data)
      .then((response) => {
        let sharedToolEmails = response.data.data;
        this.setState({
          toolDetails: { ...toolDetails, publicShare: [...sharedToolEmails] },
          showShareModal: false,
        });
      })
      .catch((error) => {
        this.toggleShareModal();
      });
  };

  addGroupModal = () => {
    let { toolDetails } = this.state;
    this.setState((prevState) => ({
      isGroupModal: !prevState.isGroupModal,
      selectedResource: toolDetails,
    }));
  };

  // closeGroupModal =( )

  updateAttachments = (data) => {
    this.setState({
      toolDetails: {
        ...this.state.toolDetails,
        attachments: [...data],
      },
    },()=>{
      console.log(this.state.toolDetails)
    });
  };

  render() {
    // console.log("daniPropsinToolDetails", this.props.history);
    let detailsSection = null;
    let moreSection = null;
    let headerSection = null;
    let commentsSection = null;
    let allowRemoveShareToolEmails = false;
    // console.log(this.state.toolDetails);
    console.log("allComments Render--- ", allComments);
    const {
      isExporting,
      showContactModal,
      showShareModal,
      showArchiveModal,
      isGroupModal,
      showAddRatingModal,
      showWarningModal,
      warningModalAction,
      toolDetails,
      orgUserList,
      allComments,
      displayComments,
      isToolRecommendedAndArchive,
      isGroupEvent
    } = this.state;
    // console.log(this.state.toolDetails);
    if (this.state && toolDetails && toolDetails.category) {
      console.log("toolDetails ---- ", toolDetails,isGroupEvent);
      allowRemoveShareToolEmails = canRemoveShareToolEmails(
        toolDetails,
        this.props.user
      );
      const canEdit = canEditTool(
        toolDetails,
        this.props.user,
        this.props.office.details,
        toolDetails.permission
      );
      // console.log(canEdit)
      const canArchiveAndRestore = canArchiveAndRestoreTool(
        toolDetails,
        this.props.user
      );
      // console.log(canEdit);
      detailsSection = (
        <DetailsSection {...this.state} toolDetails={toolDetails} />
      );
      moreSection = (
        <MoreSection
          user={this.props.user}
          canEdit={canEdit}
          canArchiveAndRestore={canArchiveAndRestore}
          editTool={this.handleEditTool}
          onExportClick={this.handleExportClick}
          onAddGroup={this.addGroupModal}
          onContactClick={this.toggleContactModal}
          onShareClick={this.handleShowShareModal}
          onArchiveClick={
            !toolDetails.isArchive.value && this.toggleArchiveModal
          }
          onRestoreTool={this.handleRestoreArchivedTool}
          onAddOrRemoveFavorite={this.handleAddOrRemoveFavorite}
          {...this.state}
        />
      );
      headerSection = (
        <HeaderSection
          user={this.props.user}
          {...this.state}
          onAddRatingClick={this.handleRateToolAllowed}
        />
      );
      commentsSection = (
        <CommentsSection
          toolDetails={toolDetails}
          user={this.props.user}
          allComments={allComments}
          displayComments={displayComments}
          onAddComment={this.handleAddComment}
          onDeleteComment={this.handleDeleteComment}
          onSeeMoreComments={this.handleSeeMoreComments}
        />
      );
    }
    // console.log(this.props.history.location.pathname)
    const isFavorites =
      this.props.history.location.pathname.indexOf("favorite") > -1;

    let toolCategory;

    if (toolDetails && toolDetails.category) {
      if (toolDetails.category == "Programs & Initiatives") {
        toolCategory = "Programs & Initiatives";
      } else {
        toolCategory = toolDetails.category;
      }
    } else {
      toolCategory = "";
    }

    let events_styling_array = ["Conferences & Events", "Diversity Calendar"];

    console.log("toolDetails.category---- ", toolDetails.category);

    let isEventStyling =
      toolDetails &&
      toolDetails._id &&
      events_styling_array.indexOf(toolDetails.category) > -1
        ? true
        : false;

    return (
      <div
        className={`${
          isEventStyling
            ? "toolkitDetailContainer"
            : "toolkitDetailContainer__p1"
        }`}
        style={{
          overflow: isExporting ? "hidden" : "auto",
          position: isEventStyling ? "fixed" : "relative",
        }}
      >
        {!isToolRecommendedAndArchive ? (
          toolDetails && toolDetails._id ? (
            isEventStyling ? (
              <span>
                <EventDetails
                  item={toolDetails}
                  popupPropCat={this.props.match.params.category}
                  updateAttachments={this.updateAttachments}
                  isGroupEvent={isGroupEvent}
                />
              </span>
            ) : (
              <div>
                <div>
                  <Row className="mt10">{headerSection}</Row>
                  <div className="tool_details_content_margins">
                    <Col sm={8} xs={12}>
                      {detailsSection}

                      <EventsMap item={toolDetails} />
                    </Col>
                    <Col sm={4} xs={12} className="">
                      <div>{moreSection}</div>
                      {!toolDetails.isRecommendedByAdmin && (
                        <div className="mt30 mb20">{commentsSection}</div>
                      )}
                    </Col>
                  </div>
                </div>
                <ContactModal
                  showModal={showContactModal}
                  toggle={this.toggleContactModal}
                  toolDetails={toolDetails}
                />
                <ShareModal
                  showModal={showShareModal}
                  toggle={this.toggleShareModal}
                  onShareTool={this.handleShareTool}
                  orgUserList={orgUserList}
                  toolDetails={toolDetails}
                  currentUser={this.props.user._id}
                  allowRemoveShareToolEmails={allowRemoveShareToolEmails}
                />
                <ArchiveModal
                  showModal={showArchiveModal}
                  toggle={this.toggleArchiveModal}
                  toolDetails={toolDetails}
                  currentUser={this.props.user}
                  archiveTool={this.handleArchiveTool}
                />
                <AddRatingModal
                  showModal={showAddRatingModal}
                  toggle={this.toggleRatingModal}
                  toolDetails={toolDetails}
                  onRateTool={this.handleRateTool}
                />
                <ToolWarningModal
                  action={warningModalAction}
                  showModal={showWarningModal}
                  toggle={this.toggleWarningModal}
                  restoreTool={this.handleRestoreArchivedTool}
                />
                {isExporting ? (
                  <div
                    className="exportToolcontainer"
                    style={{
                      display: "block",
                      position: "absolute",
                      top: "10000px",
                      zIndex: "-99999999",
                    }}
                    ref={(r) => (this.toolDetailRef = r)}
                  >
                    <ExportableTool
                      isExporting={true}
                      // ref={(r) => this.toolDetailRef = r}
                      toolDetails={toolDetails}
                      user={this.props.user}
                    />
                  </div>
                ) : null}
                {isGroupModal != false ? (
                  <AddToGroup
                    closeGroupModal={this.addGroupModal}
                    modelName={"OfficeToolkit"}
                    itemType={toolDetails.category}
                    itemId={toolDetails._id}
                    item={toolDetails}
                    isOpen={isGroupModal}
                  />
                ) : null}
              </div>
            )
          ) : null
        ) : (
          <EmptyStage {...this.props} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
    office: state.office,
    toolDetails: state.toolkit.toolDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToolEditLoaded: (data) => dispatch(actionCreators.editToolLoaded(data)),
    updateNavBar: (data) => dispatch(actionCreators.navBarUpdate(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(ToolDetails, axios));
